import { Component } from '@angular/core';
import { ShowComponent } from '@/common/component/show.component';
import { Multimedia } from '@/services/service.model';
import { InfoboxService } from '@/common/infobox/infobox.service';
import { Data2Service } from '@/common/data2.service';
import { DataBagService } from '@/common/data-bag.service';
import { DateService } from '@/common/date.service';
import { ActivatedRoute, Router } from '@angular/router';
import { QuestionService } from '@/common/question-dialog/question-dialog.service';
import { LoaderService } from '@/common/loader/loader.service';
import { UuidService } from '@/common/uuid.service';
import { LockerService } from '@/common/locker.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

export enum BannerPhotoMode {
	DESKTOP = 'desktop',
	MOBILE = 'mobile',
}

export interface BannerModel {
	name: string;
	id?: string;
	link: string;
	order?: number;
	text: string;
	isActive: boolean;
	multimedia: Multimedia | string;
	multimediaMobile: Multimedia | string;
}

@Component({
	selector: 'app-www-banner',
	templateUrl: './www-banner.component.html',
	styleUrls: ['./www-banner.component.css'],
})
export class WwwBannerComponent extends ShowComponent {
	protected apiType = 'bag';
	protected parentComponent = 'www/banner';
	protected apiUrl = '/www/banner/';
	protected apiUrlAdd = '/www/banner/';

	isActive: Array<any> = [
		{ id: true, name: 'Aktywne' },
		{ id: false, name: 'Nieaktywne' },
	];
	BannerPhotoMode = BannerPhotoMode;
	bannerForm: FormGroup;

	protected getApiUrl(): string {
		return '/www/banner/' + this.data.id + '/';
	}

	data: BannerModel = {
		name: null,
		id: null,
		link: null,
		order: 999,
		text: '',
		isActive: true,
		multimedia: null,
		multimediaMobile: null,
	};
	photo = '';
	photoMobile = '';

	constructor(
		protected api: Data2Service,
		protected bag: DataBagService,
		protected uuid: UuidService,
		protected date: DateService,
		protected infobox: InfoboxService,
		protected question: QuestionService,
		protected loader: LoaderService,
		protected locker: LockerService,
		protected route: ActivatedRoute,
		protected router: Router,
		private readonly formBuilder: FormBuilder,
	) {
		super(api, bag, uuid, date, infobox, question, loader, locker, route, router);
		this.createFormGroup();
	}

	protected afterLoadDataGet() {
		this.bannerForm.patchValue(this.data);
		this.photo = this.setMultimedia(this.data.multimedia, 'url');
		this.photoMobile = this.setMultimedia(this.data.multimediaMobile, 'url');
	}

	deletePhoto(mode: BannerPhotoMode) {
		if (mode === BannerPhotoMode.DESKTOP) {
			this.photo = '';
		} else if (mode === BannerPhotoMode.MOBILE) {
			this.photoMobile = '';
		}
	}

	protected submitConvert(data: BannerModel): BannerModel {
		const payload: BannerModel = {
			...this.bannerForm.value,
			multimedia: this.setMultimedia(this.bannerForm.controls['multimedia'].value, 'id'),
			multimediaMobile: this.setMultimedia(this.bannerForm.controls['multimediaMobile'].value, 'id'),
			order: data.order ? data.order : 999,
			id: data.id ? data.id : '',
		};

		return payload;
	}

	submit() {
		this.bannerForm.markAllAsTouched();
		if (this.bannerForm.valid) {
			super.submit();
		}
	}
	onFileSelected(event: Event, mode: BannerPhotoMode): void {
		if (!mode) {
			return;
		}
		const file = (event.target as HTMLInputElement).files[0];
		this.bag.upload('/multimedia/file/', file, (result, error) => {
			if (mode === BannerPhotoMode.DESKTOP) {
				this.bannerForm.controls.multimedia.patchValue(result);
				this.photo = result.url;
			} else if (mode === BannerPhotoMode.MOBILE) {
				this.bannerForm.controls.multimediaMobile.patchValue(result);
				this.photoMobile = result.url;
			}
		});
	}

	private setMultimedia(multimedia: string | Multimedia, parameter: string) {
		if (typeof multimedia === 'string') {
			return multimedia;
		} else if (multimedia && multimedia[parameter]) {
			return multimedia[parameter];
		} else {
			return '';
		}
	}

	private createFormGroup() {
		this.bannerForm = this.formBuilder.group({
			link: new FormControl('', [Validators.required]),
			name: new FormControl('', [Validators.required]),
			text: new FormControl('', [Validators.required]),
			isActive: new FormControl(false, []),
			multimedia: new FormControl(null, [Validators.required]),
			multimediaMobile: new FormControl(null, []),
		});
	}
}
